import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { tap } from 'rxjs';

import { TemplateConfig } from '../../dto/response/template.config';
import { TemplateConfigService } from '../../service/template-config.service';
import { GetTemplateConfig, UpdateTemplateConfig } from '../actions/templateConfig.action';

@State<TemplateConfig>({
  name: 'templateConfig',
  defaults: {
    id: '',
    site_id: '',
  },
})
@Injectable()
export class TemplateConfigState {
  constructor(private templateConfigService: TemplateConfigService) { }

  @Selector()
  static templateConfig(state: TemplateConfig) {
    return state.config;
  }

  @Selector()
  static templateTheme(state: TemplateConfig) {
    return state.theme;
  }

  @Selector()
  static templateConfigHeader(state: TemplateConfig) {
    return state.config?.header;
  }

  @Selector()
  static templateConfigFooter(state: TemplateConfig) {
    return state.config?.footer;
  }

  @Selector()
  static templateConfigAboutUs(state: TemplateConfig) {
    return state.config?.about_us;
  }

  @Selector()
  static templateConfigContactUs(state: TemplateConfig) {
    return state.config?.contact_us;
  }

  @Selector()
  static templateConfigPrivacyPolicy(state: TemplateConfig) {
    return state.config?.privacy_policy;
  }

  @Selector()
  static templateConfigTermsCondition(state: TemplateConfig) {
    return state.config?.terms_conditions;
  }

  @Selector()
  static templateConfigHome(state: TemplateConfig) {
    return state.config?.home_page;
  }

  @Selector()
  static templateConfigPDP(state: TemplateConfig) {
    return state.config?.pdp;
  }

  @Selector()
  static templateConfigPLP(state: TemplateConfig) {
    return state.config?.plp;
  }
  @Selector()
  static siteId(state: TemplateConfig) {
    return state.site_id;
  }

  @Action(GetTemplateConfig)
  getTemplateConfig(ctx: StateContext<TemplateConfig>) {
    return this.templateConfigService.getTemplateConfig().pipe(
      tap({
        next: (result: TemplateConfig) => {
          console.log(result);
          const state = ctx.getState();
          ctx.setState({
            ...state,
            id: result.id,
            site_id: result.site_id,
            config: result.config,
            theme: result.theme
          });
        },
        error: (err) => {
          throw new Error(err?.error?.message);
        },
      }),
    );
  }

  @Action(UpdateTemplateConfig)
  addToCart(ctx: StateContext<TemplateConfig>, action: UpdateTemplateConfig) {
    const state = ctx.getState();
    const templateConfig = action.templateCconfig;
    ctx.setState({
      ...state,
      id: templateConfig.id,
      site_id: templateConfig.site_id,
      config: templateConfig.config,
      theme: templateConfig.theme
    });
  }

}
